<template>
  <div class="m-3" style="height: 90vh">
    <ReportsTable
      ref="rtable"
      :columns="columnDefs"
      :settings="{title: t('customersOutstandingBalances')}"
      endpoint="reports/customer/outstanding-balances"
      @onDataLoaded="onDataLoaded"
    >
    <template #filter>
        <el-select
          filterable
          clearable
          class="col-span-12 md:col-span-3"
          :placeholder="t('creditLayaway')"
          v-model="selectedSaleType"
          @change="onSelectedSaleTypeChanged"
        >
          <el-option
            :label="t('credit_sale')"
            :value="'credit_sale'"
          ></el-option>
          <el-option
            :label="t('layaway')"
            :value="'layaway'"
          ></el-option>
          
        </el-select>
      </template>
      <template #cards>
        <div class="grid grid-cols-2 gap-4">
          <el-card shadow="never">
            <div class="flex flex-col items-center">
              <div class="text-lg text-gray-500">{{ t('totalBalances') }}</div>
              <div class="text-2xl pt-2">{{ formatMoney(totalBalances, 'IQD') }}</div>
            </div>
          </el-card>
          <el-card shadow="never">
            <div class="flex flex-col items-center">
              <div class="text-lg text-gray-500">{{ t('totalCustomersWithBalances') }}</div>
              <div class="text-2xl pt-2">{{ totalCustomersWithBalances }}</div>
            </div>
          </el-card>
        </div>
      </template>
    </ReportsTable>
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount, provide } from 'vue'
import { useI18n } from 'vue-i18n'
import { ColDef } from 'ag-grid-community'
import { useRoute, useRouter } from 'vue-router'
import { useHTTP } from '@/plugins/http'
import { useAlertModal } from '@/plugins/alert-modal/alert-modal'
import { formatMoney } from '@/utils/money'
import ReportsTable from '@/views/reports/v2/table/ReportsTable.vue'
import { formatPostgresDate } from '@/utils/date'
import User from '@/models/user/User'

// i18n
const { t } = useI18n({
  messages: {
    en: {
      customersOutstandingBalances: 'Customers Outstanding Balances',
      name: 'Name',
      outstandingBalances: 'Outstanding Balances',
      cashCustomer: 'Cash Customer',
      totalBalance: 'Total Balance',
      totalBalances: 'Total Balances',
      saleType: 'Sale Type',
      totalCustomersWithBalances: 'Customers With Balances',
      creditLayaway: 'Credit / Layaway',
      credit_sale: 'On Account',
      layaway: 'Layaway',
      any: 'Credit / Layaway',
    },
    ar: {
      customersOutstandingBalances: 'أرصدة الزبائن المستحقة',
      name: 'الاسم',
      outstandingBalances: 'Outstanding Balances',
      cashCustomer: 'زبون نقدي',
      totalBalance: 'Total Balance',
      totalBalances: 'Total Balances',
      saleType: 'Sale Type',
      totalCustomersWithBalances: 'Customers With Balances',
      creditLayaway: 'آجل / عربون',
      credit_sale: 'آجل',
      layaway: 'عربون',
      any: 'آجل / عربون',
    }
  }
})

// Data
const rtable = ref<any>()
const columnDefs = ref<ColDef[]>([])

const totalBalances = ref(0)
const totalCustomersWithBalances = ref(0)

const selectedSaleType = ref()

const http = useHTTP()
const route = useRoute()
const router = useRouter()
const alertModal = useAlertModal()

onBeforeMount(async () => {
  columnDefs.value = [
    {
      headerName: t('name'),
      field: 'name',
      checkboxSelection: true,
      headerCheckboxSelection: true,
      valueFormatter: ({ data }) => {
        if (data.id == '') {
          return t('cashCustomer')
        }
        return `${data.name}`
      }
    },
    {
      headerName: t('saleType'),
      field: 'sale_type',
      valueFormatter: ({ data }) => {
        if (data.id == '') return '';
        return t(data.sale_type)
      }
    },
    {
      headerName: t('totalBalance'),
      field: 'total_balance',
      valueFormatter: ({ data }) => {
        if (!data) return ''
        return `${formatMoney(data.total_balance, 'IQD')}`
      }
    }
  ]
})

function onDataLoaded(data: any) {
  totalBalances.value = 0
  totalCustomersWithBalances.value = 0

  for (let i = 0; i < data.length; i++) {
    if (data[i].id == '') {
      data[i].name = t('cashCustomer')
    }
    totalBalances.value += data[i].total_balance
    totalCustomersWithBalances.value += 1
  }
}

function onSelectedSaleTypeChanged(event: any) {
  rtable.value.payload.filter = selectedSaleType.value? selectedSaleType.value: null;
  rtable.value.navigate(rtable.value.payload)
}
</script>
